import inventory from "../../../Assets/Img/inventorybackground.webp";
import scanning from "../../../Assets/Img/scanning.png";
import inventoryicon from "../../../Assets/Img/inventoryicon.webp";
import inventoryhelp from "../../../Assets/Img/inventoryhelp.webp";
import dashboard from "../../../Assets/Img/dashboard.webp";
import amazon from "../../../Assets/Img/amazon.webp";
import machine from "../../../Assets/Img/machine.webp";
import mobiletracking from "../../../Assets/Img/mobiletracking.webp";
import typesinventory from "../../../Assets/Img/typesinventory.webp";
import staricon from "../../../Assets/Img/staricon.webp";
import automation from "../../../Assets/Img/automation.webp";
import inhension from "../../../Assets/Img/inhension.webp";
import Data from './Data'
import Footer from "../../../subComponent/Footer"
import NavBar from "../../../subComponent/NavBar";
const Inventory = () => {


    return (

        <div className="bg-white">
            <div className="background-setting inventory-banner-backkground">
                <div className="inventory-backdrop" >
                    <NavBar />
                    <div className="inventory-header d-flex justify-content-center align-items-center flex-column py-5">
                        <div className="inventory-icon_image  text-center">
                            <img src={inventoryicon} width="200px" height="200px" alt="Your image" />
                        </div>
                        <p className="inventory-heading text-center text-white   fs_30 fw-700  mb-0 mt-4">Inventory / WMS / MRP</p>
                        <p className="inventory-heading text-center text-white mb-0  fs_30 fw-700"> Let's Take Control</p>
                        <p className="inventory-paragraph text-center text-white futura fs_22  my-4">We Help Our Clients Track Both Simple & Complex Inventories</p>
                        <button className="filled-button fs_22 px-4 py-2 my-3 ls_3 text-white rounded-pill border-0 Poppins">
                            Contact US Now
                        </button>
                    </div>
                </div>
            </div>
            <div className="container py-5">
                <div className="invertory-banner my-5">
                    <div className="position-relative pargraph-line mx-auto ">
                        <p className=" text-center mb-5 fs_30 fw-500 ls_3 pb-2">
                            How We Can Help
                        </p>
                        <div className="gradient-line"></div>
                    </div>
                    <p className="text_section text-center fs_20 futura">
                        We Aim to Provide Everything that You Need. So That You'll Have A One-Stop-Solution
                    </p>
                    <div className="help-image_wrapper d-flex d-flex justify-content-center mt-5">
                        <div className="row">
                            <div className="col-12 inventor-help_image">
                                <img src={inventoryhelp} width="100%" alt="Your image" />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row services-wrapper py-5">
                    {Data.map(each => (
                        <div className="col-12 col-sm-6 col-lg-4">
                            <div className="background-setting Item-Hover" style={{ backgroundImage: `url(${each.Img})` }}>
                                <div className="inventory-backdrop" >
                                    <div className="inventory-header d-flex justify-content-center align-items-center flex-column py-5">
                                        <p className="inventory-heading text-center text-white fw-700 fs_19 mb-0 mt-4">{each.heading}</p>
                                        <p className="services-paragraph ls_3 text-center text-white futura pt-3 fs_14my-4">{each.text}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    )
                    )}
                </div>
                <div className="Inverntory-carousel my-5">
                    <div className="container bac position-relative">
                        <div className="position-relative pargraph-line mx-auto ">
                            <p className=" text-center mb-5 fs_30 fw-500 ls_3 pb-2 mt-5">
                                Our Clients
                            </p>
                            <div className="gradient-line"></div>
                        </div>
                        <div className="testimonial-carousel-wrapper">
                            <span id="item-1"></span>
                            <span id="item-2"></span>
                            <span id="item-3"></span>
                            <div className="testimonial-carousel-item item-1">
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <img src={inhension} width="100%" alt="Your image" />
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6 d-flex align-items-center">
                                        <p className="carousel-slider_heading fs_20 text-black ls_3 mt-4 poppins">The system helps us reduce a lot of paper work and increase traceability. Time and money invested in this project was well worth it</p>
                                    </div>
                                    <p className="carousel-slider_text text-end fs_14 ls_2 mt-3">- Mike Chan, General Manager of Inhesion Industrial (M) Sdn. Bhd.</p>
                                </div>
                                <a className="arrow arrow-prev" href="#item-3"></a>
                                <a className="arrow arrow-next" href="#item-2"></a>
                                <p className="text-start carousel-navigation fs_14 text-decoration-underline" >Read Use cases</p>
                            </div>
                            <div className="testimonial-carousel-item item-2">
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-6 ">
                                        <img src={inhension} width="100%" alt="Your image" />
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6 d-flex align-items-center">
                                        <p className="carousel-slider_heading fs_20 text-black ls_3 mt-4 poppins">The system helps us reduce a lot of paper work and increase traceability. Time and money invested in this project was well worth it</p>
                                    </div>
                                    <p className="carousel-slider_text text-end fs_14 ls_2 mt-3">- Mike Chan, General Manager of Inhesion Industrial (M) Sdn. Bhd.</p>
                                </div>
                                <a className="arrow arrow-prev" href="#item-1"></a>
                                <a className="arrow arrow-next" href="#item-3"></a>
                                <p className="text-start carousel-navigation fs_14 text-decoration-underline " >Read Use Cases</p>
                            </div>

                            <div className="testimonial-carousel-item item-3">
                                <div className="row">
                                    <div className="col-12 col-md-6 col-lg-6">
                                        <img src={inhension} width="100%" alt="Your image" />
                                    </div>
                                    <div className="col-12 col-md-6 col-lg-6  d-flex align-items-center">
                                        <p className="carousel-slider_heading fs_20 text-black ls_3 mt-4 poppins">The system helps us reduce a lot of paper work and increase traceability. Time and money invested in this project was well worth it</p>
                                    </div>
                                    <p className="carousel-slider_text text-end fs_14 ls_2 mt-3">- Mike Chan, General Manager of Inhesion Industrial (M) Sdn. Bhd.</p>
                                </div>
                                <a className="arrow arrow-prev" href="#item-2"></a>
                                <a className="arrow arrow-next" href="#item-1"></a>
                                <p className="text-start carousel-navigation fs_14 text-decoration-underline" >Read Use Cases</p>

                            </div>
                        </div>
                    </div>
                </div>
                <div className="label_section mt-5">
                    <div className="position-relative pargraph-line mx-auto mt-5 ">
                        <p className=" text-center mb-5 fs_30 fw-500 ls_3 pb-2">
                            As Featured
                        </p>
                        <div className="gradient-line"></div>
                    </div>

                    <div className="col-12 d-flex justify-content-center align-items-center gap-4 my-5" >
                        <div className="">
                            <img src={staricon} width="100%" alt="Your image" />
                        </div>
                        <div className="">
                            <img src={automation} width="100%" alt="Your image" />
                        </div>
                    </div>
                    <div className="text-center">
                        <p class="underline-with-circle-and-dot mt-3 mt-md-5 fs_22 poppins ls_2 text-black  pt-0 pt-md-3">Feature</p>
                    </div>
                    <div className="row ">
                        <div className='col-12 col-md-6 p-md-5 mt-5 '>
                            <div className="label_image">
                                <img src={typesinventory} width="100%" alt="Your image" />
                            </div>
                        </div>

                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <p className='label_heading futura-bold fs_22 700 mt-1 ls_3'>Track 4 Types of Inventory</p>
                            <ul>
                                <li className="cloud_points pb-4 mt-5 text-black futura">
                                    Standard Inventory: Standard inventory refers to the inventory that comes with a single barcode number and is tracked in quantities.
                                </li>
                                <li className="cloud_points pb-4 text-black futura">Serial Inventory: Serial numbers are generally unique numbers that identify a specific item of a given type - similar to a car registration.</li>
                                <li className="cloud_points pb-4 text-black futura">
                                    Serial with Information: Similar to serial, but in this case, there is information (e.g. quantity, expiry, manufacturing material) attached to each serial number.
                                </li>
                                <li className="cloud_points text-black futura">Batch/ Lot Inventory: A bundle or quantity of items typically produced within a single production run that are given a unique # and, usually, expiration date.</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="Section_8 label_section mt-5">
                    <div className="row ">
                        <div className="col-12 col-md-6 p-md-5 mt-5">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/iblp7TVZ-6E" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        </div>
                        <div className='col-12 col-md-6 p-md-5 mt-4'>
                            <p className='label_heading futura-bold fs_22 700 mt-5 ls_3'>Track 4 Types of Inventory</p>
                            <p className='label_descrption futura .fs_13 mt-5 ls_3'>We help you transform your business easily by implementing 1D, 2D or QR barcodes.</p>
                            <p className='label_descrption futura .fs_13 mt-3 ls_3'>
                                From there onwards, we help you track them at all stages of your production, storage or assembly line</p>
                        </div>
                    </div>
                </div>
                <div className="label_section mt-5">
                    <div className="row ">
                        <div className='col-12 col-md-6 p-md-5 mt-5 '>
                            <div className="label_image">
                                <img src={mobiletracking} width="100%" alt="Your image" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <p className='label_heading futura-bold fs_22 700 mt-4 ls_3'>Mobile Tracking</p>
                            <p className='label_descrption futura .fs_13 mt-5 ls_3'> When paired with smart devices, our system becomes even more powerful. Features could include:</p>
                            <ul>
                                <li className="cloud_points pb-4 mt-5 text-black">
                                    Stock Movement Update Any Where.
                                </li>
                                <li className="cloud_points pb-4 text-black">Operate Anywhere (with Internet)</li>
                                <li className="cloud_points pb-4 text-black">
                                    Add Photos Easily for Audit or Control
                                </li>
                                <li className="cloud_points text-black">Lower Cost of Implementation</li>
                            </ul>
                        </div>
                    </div>

                </div>

                <div className="Section_8 label_section mt-5">
                    <div className="row ">
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <div className="label_image">
                                <img src={scanning} width="100%" alt="Your image" />
                            </div>
                        </div>
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <p className='label_heading futura-bold fs_22 700 mt-5 ls_3'>Customized Labels</p>
                            <p className='label_descrption futura .fs_13 mt-5 ls_3'>Create your own supply chain labels for ease of scanning and identification. Not only does SmartB's system read 1D, 2D and QR codes, we also generate them if required.
                                More importantly, all labels generated from our system forms part of our database management.s</p>
                        </div>
                    </div>
                </div>

                <div className="Section_9 label_section mt-5">
                    <div className="row ">
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <div className="label_image">
                                <img src={dashboard} width="100%" alt="Your image" />

                            </div>
                        </div>
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <p className='label_heading futura-bold fs_22 fw-700 '>Inventory Analytics / Dashboard</p>
                            <p className='label_descrption futura .fs_13 mt-5'>SmartB integrates with Market Leaders in create powerful Dashboards for our customers. Without a doubt, critical decisions should be made based on facts and not guesstimates.</p>
                            <p className='label_descrption futura .fs_13'>Hence, having data at your fingertips means having the tools to make real decisions.</p>
                        </div>
                    </div>

                </div>
                <div className="Section_10 label_section mt-5">
                    <div className="row ">
                        <div className='col-12 col-md-6 p-md-5 mt-5 d-flex align-items-center'>
                            <div className="label_image">
                                <img src={amazon} width="100%" alt="Your image" />

                            </div>
                        </div>
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <p className='label_heading futura-bold fs_22 700 mt-5 ls_3'>Secured Cloud Storage</p>
                            <p className='label_descrption futura .fs_13 mt-5 ls_3'>SmartB's data is stored using Amazon's Simple Storage Service (S3). This means:</p>
                            <ul>
                                <li className="cloud_points pb-4 mt-5 text-black">
                                    Hosted on the world's No.1 cloud infrastructure, Amazon Web Services.
                                </li>
                                <li className="cloud_points pb-4 text-black">Trusted by Fortune 500 companies and banks</li>
                                <li className="cloud_points pb-4 text-black">
                                    Access your database from anywhere with your account
                                </li>
                                <li className="cloud_points text-black">Amazon S3 is designed for 99.999999999% (11 9's) of durability</li>
                            </ul>
                        </div>
                    </div>

                </div>
                <div className="Section_11 label_section mt-5">
                    <div className="row ">
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <div className="label_image">
                                <img src={machine} width="100%" alt="Your image" />

                            </div>
                        </div>
                        <div className='col-12 col-md-6 p-md-5 mt-5'>
                            <p className='label_heading futura-bold fs_22 700 mt-1 ls_3'>Machine Learning Meets Inventory</p>
                            <p className='label_descrption futura .fs_13 mt-5 ls_3'>At SmartB, we combine the latest technology to help clients grow. Now, product or item identification can now be done using image recognition solutions. That means, no barcode is required any more. More than that, different data can now be collected where it was impossible before this.</p>
                        </div>
                    </div>

                </div>
                <div className="Section_12 vedio_section mt-5">
                    <div className="clients_heading text-center fs_30 fw-500  mt-5 mb-5 text-black ">
                        Hear What Our Clients' Say
                    </div>

                    <div className="row">
                        <div className="col-12 col-md-6">
                            <iframe width="560" height="315" src="https://www.youtube.com/embed/khgotvmUfOs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        </div>

                        <div className="col-12 col-md-6">
                            <iframe width="100%" height="315" src="https://www.youtube.com/embed/rv1W-OmtnXQ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>

            </div>
            <div className="background-setting inventory-banner-backkground">
                <div className="inventory-backdrop">
                    <Footer />
                </div>
            </div>
        </div>
    )
}
export default Inventory